import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCursorClick12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCursorClick12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.085 4.864a2.998 2.998 0 1 0-3.079 3.091l.295.996a3.998 3.998 0 1 1 3.78-3.79zM5.276 6.187q-.092.015-.189.015a1.245 1.245 0 1 1 1.231-1.057l4.404 1.259a.5.5 0 0 1 .06.94l-1.82.78 1.976 1.976a.5.5 0 1 1-.707.707L8.254 8.831l-.78 1.82a.5.5 0 0 1-.94-.06zM7.901 7.49l1.194-.511-2.78-.794.794 2.779.511-1.192.012-.028.073-.17.171-.073z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCursorClick12);
